import * as React from "react";

import { ConnectProto } from "@racoon/api";
import { Namespace, useDateFnsLocale, useT } from "@racoon/i18n";
import { fromTimestamp } from "@racoon/lib";

import { fullName } from "~/shared/helpers";
import { Person } from "~/shared/ui/person";
import { SectionCaption } from "~/shared/ui/section-caption";
import { formatReportTime } from "../model/report-time";

/** A person's last save of the job (not a driver's or the system's); needs GetJobById's job. */
export const ManualChangeBlock: React.FC<{ job: ConnectProto.Job }> = ({ job }) => {
  const t = useT();
  const dateLocale = useDateFnsLocale();
  const updatedAt = fromTimestamp(job.updatedAt);

  const editor = job.updatedBy;
  if (!editor || editor.role === ConnectProto.UserRole.DRIVER || !updatedAt) return null;

  return (
    <div
      data-testid="manual-change"
      className="flex flex-col gap-3 rounded-lg bg-surface-error-light p-3 text-xs leading-4"
    >
      <SectionCaption className="!text-text-error">
        {t(Namespace.PhotoReport, "manualChange")}
      </SectionCaption>
      <div className="flex flex-col gap-2">
        <Person
          name={fullName(editor)}
          tone="bg-icon-success text-white"
          spacing="wide"
          testId="manual-change-editor"
        />
        <span className="text-text-body" data-testid="manual-change-at">
          {formatReportTime(updatedAt, dateLocale)}
        </span>
      </div>
    </div>
  );
};
